export default "__VITE_ASSET__BkwFz395__"